import { render, staticRenderFns } from "./IncreaseThemeRanking.vue?vue&type=template&id=22f1c718"
import script from "./IncreaseThemeRanking.vue?vue&type=script&lang=js"
export * from "./IncreaseThemeRanking.vue?vue&type=script&lang=js"
import style0 from "./IncreaseThemeRanking.vue?vue&type=style&index=0&id=22f1c718&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports